export default __webpack_public_path__ + "static/media/rating_web-lg@2x.69f3fda0.webp";